import { useCallback, useMemo, useState } from "react";
import InputMoney from "@/common/components/form/CurrencyInputFormik";
import { useCalculateInstallmentOptions } from "@/modules/renters/helpers/calculationUtils";
import { BILLING_TYPE } from "@/types/payment.type";
import ComboBoxFormik from "@/common/components/form/ComboBoxFormik";

interface TraditionalDepositProps {
  paymentMethod: string;
  deposit: number;
  onPaymentMethodChange: (method: string) => void;
  onDepositChange: (value: number) => void;
}

export function TraditionalDeposit({
  paymentMethod,
  deposit,
  onPaymentMethodChange,
  onDepositChange
}: TraditionalDepositProps) {
  const [, setSelectedInstallmentOption] = useState('0');

  const calculateInstallmentOptions = useCalculateInstallmentOptions();
  const installmentOptions = useMemo(() => {
    return calculateInstallmentOptions(deposit, 3);
  }, [deposit, calculateInstallmentOptions]);

  const paymentOptions = [
    { label: "-", value: "" },
    { label: "Cartão de Crédito", value: BILLING_TYPE.CREDIT_CARD },
    { label: "Pix", value: BILLING_TYPE.PIX },
  ];

  const handlePaymentMethodChange = useCallback((selectedOption) => {
    onPaymentMethodChange(selectedOption);
  }, [onPaymentMethodChange]);

  const handleInstallmentOptionChange = useCallback((option) => {
    setSelectedInstallmentOption(option);
  }, []);

  return (
    <section className="space-y-4">
      <ComboBoxFormik
        className="mt-4"
        name="methodPayment"
        label="Escolha o método de pagamento:"
        options={paymentOptions}
        required={true}
        onChange={handlePaymentMethodChange}
      />

      {paymentMethod === 'CREDIT_CARD' && (
        <section className="space-y-4">
          <div className="bg-yellowPrimary/50 border-l-4 border-yellow-500 p-4" role="alert">
            <p>
              Informa o cliente que para todo pagamento na opção de crédito será cobrado um valor adicional de R$ 50,00 sobre o valor total.
            </p>
          </div>

          <div className="space-y-4">
            <InputMoney
              className="mt-6"
              name="creditDeposit"
              label="Digite o valor do Caução"
              required={true}
              onValueChange={onDepositChange}
            />

            <ComboBoxFormik
              name="installmentOption"
              label="Escolha a opção de parcelamento:"
              options={installmentOptions}
              required={true}
              onChange={handleInstallmentOptionChange}
            />
          </div>
        </section>
      )}

      {paymentMethod === 'PIX' && (
        <InputMoney
          className="mt-6"
          name="deposit"
          label="Digite o valor do Caução"
          required={true}
          onValueChange={onDepositChange}
        />
      )}
    </section>
  );
}